module.exports = __webpack_public_path__ + "static/img/escritorio.372f50d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/escritorio.jpeg
// module id = avEL
// module chunks = 1